<div class="rx-intuitive-crown__selectors" data-testid="restoration-selectors">
	<rx-select
		*ngIf="specificationOptions?.length"
		id="specification"
		[label]="'ToothEditor.Specification' | translate"
		[formControl]="specificationControl"
		[options]="specificationOptions"
		[isDisabled]="isReadOnly"
		[isRequired]="!!(shouldValidateForSend$ | async)"
		[isCancellable]="specificationSelectCancellable"
		(cancelSelectionEvent)="handleCancelSpecification()"
		name="specification"
	></rx-select>
	<rx-favorite-selector
		data-testid="restoration-material"
		[label]="'ToothEditor.Material' | translate"
		[formControl]="materialControl"
		[isReadOnly]="isReadOnly"
		[isDisabled]="materialFavoriteDisabled"
		[options]="materialOptions"
		[favoriteName]="favoriteMaterial"
		[enableSimpleMode]="!!(isNotDoctor$ | async)"
		[isRequired]="!!(shouldValidateForSend$ | async)"
		[isCancellable]="(shouldValidateForSend$ | async) === false"
		(cancelSelection)="handleCancelMaterial($event)"
		id="material"
		name="material"
	></rx-favorite-selector>
	<rx-select
		id="shadeSystem"
		[label]="'ToothEditor.ShadeSystem' | translate"
		[formControl]="shadeSystemControl"
		[options]="shadeSystemOptions"
		[isDisabled]="shadeControlsDisabled"
		name="shadeSystem"
	></rx-select>
	<rx-select
		*ngIf="!isOtherShadeSystemSelected"
		id="body"
		[label]="'ToothEditor.Body' | translate"
		[formControl]="bodyControlAsIdName"
		[options]="incisalBodyGingivalOptions"
		[isDisabled]="shadeControlsDisabled"
		[isRequired]="bodyShadeRequired"
		[isCancellable]="bodyShadeCancellable"
		name="body"
	></rx-select>
	<rx-text-input
		*ngIf="isOtherShadeSystemSelected"
		[label]="'ToothEditor.Body' | translate"
		maxlength="10"
		[formControl]="bodyControlAsAString"
		[isDisabled]="shadeControlsDisabled"
		[isRequired]="bodyShadeRequired"
		name="bodyControl"
	>
	</rx-text-input>
</div>
